import moment from 'moment'
import MenuGroupItem from '@/model/MenuGroupItem'
import DailyMenuOption from '@/model/DailyMenuOption'
import { StructuredMenuOfferResponseItem } from '@/types/service-response'
import i18n from "@/plugins/i18n";

export default class DailyMenuOffer {

  private constructor (
    readonly date: Date,
    readonly menuGroupList: MenuGroupItem[]
  ) {}

  get isMenuOfferedByDay (): boolean {

    let isOffered = true

    this.menuGroupList.forEach((group: MenuGroupItem) => {

      if (group.subGroupList.length > 0) {
        group.subGroupList.forEach((subgroup: MenuGroupItem) => {
          if (subgroup.optionList.length > 0) {
            subgroup.optionList.forEach((option: DailyMenuOption) => {

              if (!option.offer)
                isOffered = false
            })
          }
        })
      }

      if (group.optionList.length > 0) {
        group.optionList.forEach((option: DailyMenuOption) => {
          if (!option.offer)
            isOffered = false
        })
      }

    })
    return isOffered
  }

  get dayName (): string {
    return moment(this.date).locale(i18n.locale).format('dddd')
  }

  // FIXME: DEPRECATED
  get formatedDate (): string {
    return moment(this.date).format('D.M.Y')
  }

  get displayDate (): string {
    return moment(this.date).format('D.M.Y')
  }

  get dateWithoutYear (): string {
    return moment(this.date).format('D.M.')
  }

  get dateYear (): string {
    return moment(this.date).format('Y')
  }

  get formatedDbDate (): string {
    const date = moment(this.date)
    return date.format('Y-MM-DD')
  }

  static createFromResponse (responseData: StructuredMenuOfferResponseItem): DailyMenuOffer {
    return new DailyMenuOffer(
      moment(responseData.date).toDate(),
      MenuGroupItem.createFromList(responseData.data)
    )
  }
}
